import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-estudos-cyrela',
  templateUrl: './estudos-cyrela.component.html',
  styleUrls: ['./estudos-cyrela.component.css']
})
export class EstudosCyrelaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
